import { render, staticRenderFns } from "./ProjectAssetGroup.vue?vue&type=template&id=1fd2803c"
import script from "./ProjectAssetGroup.vue?vue&type=script&lang=js"
export * from "./ProjectAssetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports